import './SqlDataTransfer.scss';
import guidePDF from '../../assets/documents/SQL Data Transfer Guide.pdf';

function SqlDataTransfer(props) {

  function handleDownload() {
    const link = document.createElement("a");
    link.href = guidePDF;
    link.download = "SQL Data Transfer Guide.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="sql-data-transfer-container"> 
      <h2>SQL Data Transfer</h2>
      <p>
        In addition to CSV and JSON files we can also supply data directly to a SQL server database hosted
        by yourself. We provide a client application that can be run on any PC or Server,
        that has an internet connection and can connect to your SQL server. Once configured,
        the application will connect to our servers and download the database(s). This process can be
        scheduled to run at a convenient time.
      </p>
      <div className='button-common-properties link-container-flex'>
        <a className='white-text' href={props.env.sqlDataTransferDownloadUrl}>Download Data Transfer Application</a>
      </div>
      <div className='info-text'>
        For more information on the data structures and schemas
        <a className='click-here' href="https://developer.cap.co.uk/datafiles" target='_blank' rel='noreferrer'> click here.</a>
      </div>
      <button className='button-common-properties button white-text' onClick={handleDownload}>SQL Data Transfer Guide</button>
    </div>
  );
}

export default SqlDataTransfer;